import React, { useState, useRef, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUsersByID,
  getUserAvailablePromotion,
} from "../../store/slices/user";
import useAuth from "../../hooks/useAuth";
import axios from "axios";
import scbIcon from "../../assets/bankicon/014.webp";
import truemoneyIcon from "../../assets/bankicon/true.webp";
import ktbIcon from "../../assets/bankicon/006.webp";
import kbankIcon from "../../assets/bankicon/004.webp";
import bblIcon from "../../assets/bankicon/002.webp";
import ttbIcon from "../../assets/bankicon/011.webp";
import gsbIcon from "../../assets/bankicon/030.webp";
import krungsriIcon from "../../assets/bankicon/025.webp";
import baacIcon from "../../assets/bankicon/034.webp";
import uobIcon from "../../assets/bankicon/024.webp";
import ghbIcon from "../../assets/bankicon/033.webp";
import cimbIcon from "../../assets/bankicon/022.webp";
import islamIcon from "../../assets/bankicon/066.webp";
import kkpIcon from "../../assets/bankicon/069.webp";
import promptpayIcon from "../../assets/bankicon/promptpay.webp";
import styles from "./Deposit.module.css";
import SlipUploadPanel from "./SlipUploadPanel";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3033";

export default function Deposit() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { singleUsers, userAvailablePromotion } = useSelector((s) => s.user);

  const [method, setMethod] = useState("onpay");
  const [amount, setAmount] = useState("");
  const [qrDataUrl, setQrDataUrl] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);
  const [bibpayData, setBibpayData] = useState(null);
  const [bibpayError, setBibpayError] = useState("");
  const [onpayError, setOnpayError] = useState("");
  const [bibpayLoading, setBibpayLoading] = useState(false);
  const [bankData, setBankData] = useState([]);
  const [slipUploadEnabled, setSlipUploadEnabled] = useState(true);
  const [gsbAccounts, setGsbAccounts] = useState([]);
  const [copiedGsbId, setCopiedGsbId] = useState(null);
  const [helper, setHelper] = useState(false);
  const [helper2, setHelper2] = useState(false);
  const [depositMethods, setDepositMethods] = useState([
    {
      id: "onpay",
      name: "ฝากออโต้ QR",
      icon: "solar:card-bold",
      available: false,
    },
    {
      id: "bibpay",
      name: "ฝากออโต้ QR",
      icon: "solar:wallet-bold",
      available: false,
    },
    {
      id: "autodeposit",
      name: "ฝากออโต้",
      icon: "solar:banknote-2-bold-duotone",
      available: false,
    },
    {
      id: "gsbauto",
      name: "ฝากออโต้ ออมสิน",
      icon: "solar:banknote-2-bold-duotone",
      available: false,
    },
    {
      id: "truemoney",
      name: "ทรูมันนี่วอลเลท",
      icon: "solar:smartphone-2-bold",
      available: false,
    },
    {
      id: "slipupload",
      name: "อัพโหลดสลิป",
      icon: "solar:bill-list-bold-duotone",
      available: true,
    },
  ]);
  const intervalRef = useRef(null);

  const account = Array.isArray(singleUsers) ? singleUsers[0] : null;

  const storedId =
    user?.id ||
    account?.id ||
    (typeof window !== "undefined" ? localStorage.getItem("userId") : null);

  const getBankLogo = (bankCode) => {
    const map = {
      true: truemoneyIcon,
      "014": scbIcon,
      "006": ktbIcon,
      "004": kbankIcon,
      "002": bblIcon,
      "011": ttbIcon,
      "030": gsbIcon,
      "025": krungsriIcon,
      "034": baacIcon,
      "024": uobIcon,
      "033": ghbIcon,
      "022": cimbIcon,
      "066": islamIcon,
      "069": kkpIcon,
      promptpay: promptpayIcon,
    };
    return map[bankCode] || scbIcon;
  };

  const getBankName = (bankCode) => {
    const map = {
      true: "ทรูมันนี่วอลเล็ท",
      "014": "ธนาคารไทยพาณิชย์",
      "006": "ธนาคารกรุงไทย",
      "004": "ธนาคารกสิกรไทย",
      "002": "ธนาคารกรุงเทพ",
      "011": "ธนาคารทีทีบี",
      "030": "ธนาคารออมสิน",
      "025": "ธนาคารกรุงศรี",
      "034": "ธนาคารธ.ก.ส.",
      "024": "ธนาคารUOB",
      "033": "ธนาคารอาคารสงเคราะห์",
      "022": "ธนาคารCIMB",
      "066": "ธนาคารอิสลาม",
      "069": "ธนาคารเกียรตินาคิน",
      promptpay: "พร้อมเพย์",
    };
    return map[bankCode] || "ธนาคาร";
  };

  const quickAmounts = [100, 300, 500, 1000];

  const getMinDeposit = (depositMethod) =>
    depositMethod === "onpay" ? 100 : 10;

  // Fetch bank data from API
  useEffect(() => {
    const fetchBankData = async () => {
      try {
        const [bankResponse, slipSettingResponse, gsbResponse] =
          await Promise.all([
            axios.get(`${API_BASE_URL}/bank`),
            axios.get(`${API_BASE_URL}/slip/setting`),
            axios
              .get(`${API_BASE_URL}/gsbauto/accounts`)
              .catch(() => null),
          ]);
        setGsbAccounts(
          Array.isArray(gsbResponse?.data?.data) ? gsbResponse.data.data : [],
        );
        if (bankResponse.data && bankResponse.data.data) {
          setBankData(bankResponse.data.data);
        }
        setSlipUploadEnabled(
          Boolean(slipSettingResponse?.data?.data?.customerSlipUploadEnabled),
        );
      } catch (error) {
        console.error("Error fetching bank data:", error);
      }
    };

    fetchBankData();
  }, []);

  useEffect(() => {
    updateDepositMethodsAvailability(bankData);
  }, [bankData, slipUploadEnabled, gsbAccounts]);

  // Fetch user data from API
  useEffect(() => {
    if (storedId) dispatch(getUsersByID({ id: storedId }));
  }, [storedId, dispatch]);

  useEffect(() => {
    if (storedId) dispatch(getUserAvailablePromotion(storedId));
  }, [storedId, dispatch]);

  // Update deposit methods availability based on bank data
  const updateDepositMethodsAvailability = (banks) => {
    const isOnpayActive = banks.some(
      (bank) =>
        (bank.bankname === "onpay" || bank.bankname === "fairpay") &&
        bank.status === "ACTIVE",
    );
    const isBibpayActive = banks.some(
      (bank) => bank.bankname === "bibpay" && bank.status === "ACTIVE",
    );
    const isAutoDepositActive = banks.some(
      (bank) => bank.bankname === "scb" && bank.status === "ACTIVE",
    );
    const isTruemoneyActive = banks.some(
      (bank) => bank.bankname === "true" && bank.status === "ACTIVE",
    );
    const isGsbAutoActive =
      gsbAccounts.length > 0 &&
      banks.some(
        (bank) => bank.bankname === "gsbauto" && bank.status === "ACTIVE",
      );

    setDepositMethods((prev) =>
      prev.map((method) => ({
        ...method,
        available:
          (method.id === "onpay" && isOnpayActive) ||
          (method.id === "bibpay" && isBibpayActive) ||
          (method.id === "autodeposit" && isAutoDepositActive) ||
          (method.id === "gsbauto" && isGsbAutoActive) ||
          (method.id === "truemoney" && isTruemoneyActive) ||
          (method.id === "slipupload" && slipUploadEnabled),
      })),
    );

    // Default tab when open: prefer "onpay" if available.
    // Otherwise, keep current selection if it's still available; else fall back.
    const availability = {
      onpay: isOnpayActive,
      bibpay: isBibpayActive,
      autodeposit: isAutoDepositActive,
      gsbauto: isGsbAutoActive,
      truemoney: isTruemoneyActive,
      slipupload: slipUploadEnabled,
    };

    const fallbackOrder = [
      "onpay",
      "autodeposit",
      "gsbauto",
      "truemoney",
      "bibpay",
      "slipupload",
    ];

    setMethod((current) => {
      if (availability.onpay) return "onpay";
      if (availability[current]) return current;
      return fallbackOrder.find((id) => availability[id]) || current;
    });
  };

  useEffect(() => {
    if (countdown === 0 && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [countdown]);

  const generateQr = async () => {
    const minDeposit = getMinDeposit(method);
    const a = Number(amount) || 0;
    if (a < minDeposit) return;

    setIsGenerating(true);
    setOnpayError("");

    try {
      const amountNum = parseInt(String(amount), 10);
      if (!Number.isFinite(amountNum) || amountNum < minDeposit) {
        setOnpayError(
          `กรุณากรอกจำนวนเงินเป็นจำนวนเต็มอย่างน้อย ${minDeposit} บาท`,
        );
        return;
      }

      const response = await axios.post(
        `${API_BASE_URL}/onpay/deposit/create-qr-code`,
        {
          amount: String(amountNum),
          userId: storedId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      const payload = response.data;
      const qrUrl =
        payload?.qr_code_url ||
        payload?.data?.qr_code_url ||
        payload?.qrCodeUrl ||
        payload?.data?.qrCodeUrl;
      const qrBase64 =
        payload?.qr_code ||
        payload?.data?.qr_code ||
        payload?.qrCode ||
        payload?.data?.qrCode;

      const imageSrc = qrUrl
        ? String(qrUrl)
        : qrBase64
          ? `data:image/png;base64,${String(qrBase64)}`
          : null;

      if (!imageSrc) {
        throw new Error(
          payload?.message || "ไม่พบข้อมูล QR Code จากระบบชำระเงิน",
        );
      }

      setQrDataUrl(imageSrc);

      // Start countdown (5 minutes)
      setCountdown(300);
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCountdown((c) => {
          if (c <= 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            return 0;
          }
          return c - 1;
        });
      }, 1000);
    } catch (error) {
      console.error("Onpay error:", error);
      setOnpayError(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "เกิดข้อผิดพลาดในการสร้าง QR Code",
      );
    } finally {
      setIsGenerating(false);
    }
  };

  const handleBibpaySubmit = async () => {
    const amountNum = parseInt(amount);
    if (!amount || amountNum < 10 || !Number.isInteger(amountNum)) {
      setBibpayError("กรุณากรอกจำนวนเงินเป็นจำนวนเต็มอย่างน้อย 10 บาท");
      return;
    }

    setBibpayLoading(true);
    setBibpayError("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/bibbyx/create-charge`,
        {
          amount: amountNum,
          userId: singleUsers?.[0]?.id,
          username: singleUsers?.[0]?.username,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      if (response.data && response.data.success) {
        setBibpayData(response.data.data);
        setQrDataUrl(response.data.data.qrCodeImage); // Fixed: access nested qrCodeImage

        // Start countdown (15 minutes)
        setCountdown(900);
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
          setCountdown((c) => {
            if (c <= 1) {
              clearInterval(intervalRef.current);
              intervalRef.current = null;
              return 0;
            }
            return c - 1;
          });
        }, 1000);
      } else {
        setBibpayError(
          response.data?.message || "เกิดข้อผิดพลาดในการสร้างธุรกรรม",
        );
      }
    } catch (error) {
      console.error("BiBPAY error:", error);

      if (error.code === "ERR_NETWORK") {
        setBibpayError("ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้");
      } else if (error.response?.status === 404) {
        setBibpayError("ไม่พบบริการที่ร้องขอ");
      } else if (error.response?.status === 503) {
        setBibpayError("ระบบชำระเงินไม่พร้อมใช้งาน กรุณาลองใหม่อีกครั้ง");
      } else if (error.response?.status === 500) {
        setBibpayError("เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์");
      } else {
        setBibpayError(
          error.response?.data?.error ||
            error.response?.data?.message ||
            error.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อ",
        );
      }
    } finally {
      setBibpayLoading(false);
    }
  };

  const saveQr = () => {
    if (!qrDataUrl) return;
    const link = document.createElement("a");
    link.href = qrDataUrl;
    link.download = `deposit_${method}_${Date.now()}.png`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const formatTime = (s) => {
    const mm = String(Math.floor(s / 60)).padStart(2, "0");
    const ss = String(s % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const resetAll = () => {
    setQrDataUrl(null);
    setCountdown(0);
    setAmount("");
    setBibpayData(null);
    setBibpayError("");
    setOnpayError("");
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const promotionDetail = singleUsers?.[0]?.PromotionDetail;
  const promotionStatus = singleUsers?.[0]?.PromotionStatus;
  const promotionID = singleUsers?.[0]?.PromotionID;
  const receivePromo = userAvailablePromotion?.find(
    (item) => item.PromotionID === promotionID,
  );

  const selectedMethodData = depositMethods.find((m) => m.id === method);
  const minDeposit = getMinDeposit(method);
  const canSubmit = Number(amount) >= minDeposit;

  return (
    <div className={styles.wrapper}>
      {/* ── Hero ── */}
      <div className={styles.hero}>
        <div className={styles.heroGlow} />
        <span className={styles.heroEmoji}>💰</span>
        <h2 className={styles.heroTitle}>ฝากเงิน</h2>
        <p className={styles.heroDesc}>
          เลือกช่องทางและระบุจำนวนเงินเพื่อเติมเครดิต
        </p>
      </div>

      {/* ── Method Selector ── */}
      <div className={styles.sectionTitle}>🏦 เลือกช่องทางฝากเงิน</div>
      <div className={styles.methodGrid}>
        {depositMethods
          .filter((m) => m.available)
          .map((m) => (
            <button
              key={m.id}
              className={`${styles.methodCard} ${method === m.id ? styles.methodCardActive : ""}`}
              onClick={() => {
                setMethod(m.id);
                resetAll();
              }}
            >
              <div className={styles.methodIcon}>
                <Icon icon={m.icon} width={20} />
              </div>
              <span className={styles.methodLabel}>{m.name}</span>
            </button>
          ))}
      </div>

      {/* ── Promotion Info ── */}
      {promotionDetail && (
        <div className={styles.promoStrip}>
          <div className={styles.promoIcon}>
            <Icon icon="mdi:gift" width={22} color="#fff" />
          </div>
          <div className={styles.promoContent}>
            <span className={styles.promoLabel}>โปรโมชั่นที่เลือก</span>
            <span className={styles.promoName}>{promotionDetail}</span>
            {promotionStatus === "ACTIVE" && (
              <span className={styles.promoBadge}>✓ กำลังใช้งาน</span>
            )}
            <span className={styles.promoHint}>
              💡 กรุณาฝากตามเงื่อนไขโปรโมชั่นเพื่อรับโบนัส
            </span>
          </div>
        </div>
      )}

      {/* ── Recommended Amount ── */}
      {receivePromo && (
        <div className={styles.recommendCard}>
          <div className={styles.recommendIcon}>
            <Icon icon="mdi:information-outline" width={20} />
          </div>
          <div className={styles.recommendBody}>
            <span className={styles.recommendLabel}>
              จำนวนเงินที่แนะนำในการฝาก
            </span>
            <div className={styles.recommendAmount}>
              ฿{receivePromo.BonusDepMaximum?.toLocaleString()}
            </div>
            <span className={styles.recommendNote}>
              ระบบจะใช้ยอดนี้ในการคำนวณโบนัสตามเงื่อนไขโปรโมชั่น
            </span>
          </div>
        </div>
      )}

      {/* ── QR Methods (OnPay / BibPay) ── */}
      {selectedMethodData &&
        selectedMethodData.available &&
        !qrDataUrl &&
        (method === "onpay" || method === "bibpay") && (
          <div className={styles.formCard}>
            <div className={styles.formHeader}>
              <div className={styles.formHeaderIcon}>
                <Icon icon={selectedMethodData.icon} width={22} />
              </div>
              <div className={styles.formHeaderText}>
                <div className={styles.formHeaderTitle}>
                  {selectedMethodData.name}
                </div>
                <div className={styles.formHeaderHint}>
                  สแกน QR Code เพื่อฝากเงินอัตโนมัติ
                </div>
              </div>
              <span className={styles.minBadge}>ขั้นต่ำ 100 ฿</span>
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>
                จำนวนเงินที่ต้องการฝาก (บาท)
              </label>
              <input
                className={styles.input}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="ระบุจำนวนเงิน"
                type="number"
              />
            </div>

            <div className={styles.quickRow}>
              {quickAmounts.map((amt) => (
                <button
                  key={amt}
                  className={styles.quickPill}
                  onClick={() => setAmount(amt.toString())}
                >
                  ฿{amt}
                </button>
              ))}
            </div>

            {method === "bibpay" && bibpayError && (
              <div className={styles.errorBox}>
                <span className={styles.errorIcon}>⚠️</span>
                <span>{bibpayError}</span>
              </div>
            )}

            {method === "onpay" && onpayError && (
              <div className={styles.errorBox}>
                <span className={styles.errorIcon}>⚠️</span>
                <span>{onpayError}</span>
              </div>
            )}

            <button
              className={styles.submitBtn}
              onClick={method === "bibpay" ? handleBibpaySubmit : generateQr}
              disabled={
                (method === "bibpay" ? bibpayLoading : isGenerating) ||
                !canSubmit
              }
            >
              {(method === "bibpay" ? bibpayLoading : isGenerating) ? (
                <>
                  <Icon icon="mdi:loading" width={18} className="spin" />
                  กำลังสร้าง QR Code...
                </>
              ) : (
                <>
                  <Icon icon="mdi:qrcode" width={18} />
                  สร้าง QR Code
                </>
              )}
            </button>
          </div>
        )}

      {/* ── Auto Deposit (Bank Transfer) ── */}
      {selectedMethodData &&
        selectedMethodData.available &&
        method === "autodeposit" && (
          <div className={styles.bankSection}>
            <div className={styles.bankSectionHeader}>
              <div className={styles.bankSectionIcon}>
                <Icon icon="solar:banknote-2-bold-duotone" width={22} />
              </div>
              <div className={styles.bankSectionLabel}>
                <span className={styles.bankSectionTitle}>
                  {selectedMethodData.name}
                </span>
                <span className={styles.bankSectionHint}>
                  โอนเงินเข้าบัญชีธนาคารด้านล่างครับ
                </span>
              </div>
            </div>
            <div className={styles.bankSectionBody}>
              {bankData
                .filter(
                  (data) =>
                    data.isMain === "MAINBANK" && data.status === "ACTIVE",
                )
                .map((row) => (
                  <div key={row.banknumber} className={styles.bankCard}>
                    <div className={styles.bankCardTop}>
                      <img
                        className={styles.bankLogo}
                        src={scbIcon}
                        alt="SCB"
                        loading="lazy"
                      />
                      <div className={styles.bankMeta}>
                        <span className={styles.bankName}>
                          ธนาคารไทยพาณิชย์ (SCB)
                        </span>
                        <span className={styles.bankNumber}>
                          {row.banknumber}
                        </span>
                        <span className={styles.bankOwner}>
                          ชื่อบัญชี: {row.bankownername}
                        </span>
                      </div>
                    </div>
                    <button
                      className={`${styles.copyBtn} ${helper2 ? styles.copyBtnDone : ""}`}
                      onClick={() => {
                        navigator.clipboard.writeText(row.banknumber);
                        setHelper2(true);
                        setTimeout(() => setHelper2(false), 2000);
                      }}
                    >
                      <Icon
                        icon={
                          helper2
                            ? "solar:check-circle-bold"
                            : "solar:copy-bold"
                        }
                        width={16}
                      />
                      {helper2 ? "คัดลอกแล้ว" : "คัดลอกเลขบัญชี"}
                    </button>
                  </div>
                ))}

              <div className={styles.instructionCard}>
                <div className={styles.instructionTitle}>📌 วิธีการฝากเงิน</div>
                <ul className={styles.instructionList}>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>1</span>
                    <span>โอนเงินเข้าบัญชีข้างต้น</span>
                  </li>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>2</span>
                    <span>
                      {gsbAccounts.some((row) => row.autoTopup)
                        ? "ระบบจะเติมเครดิตให้อัตโนมัติภายใน 1-5 นาที"
                        : "หลังโอนแล้ว กรุณาแจ้งเจ้าหน้าที่พร้อมสลิปเพื่อเติมเครดิต"}
                    </span>
                  </li>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>3</span>
                    <span>หากเครดิตไม่เข้า กรุณาติดต่อเจ้าหน้าที่</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

      {/* ── Auto Deposit GSB (LINE GSB NOW) ── */}
      {selectedMethodData &&
        selectedMethodData.available &&
        method === "gsbauto" && (
          <div className={styles.bankSection}>
            <div className={styles.bankSectionHeader}>
              <div className={styles.bankSectionIcon}>
                <Icon icon="solar:banknote-2-bold-duotone" width={22} />
              </div>
              <div className={styles.bankSectionLabel}>
                <span className={styles.bankSectionTitle}>
                  {selectedMethodData.name}
                </span>
                <span className={styles.bankSectionHint}>
                  โอนเงินเข้าบัญชีออมสินด้านล่างครับ
                </span>
              </div>
            </div>
            <div className={styles.bankSectionBody}>
              {gsbAccounts.map((row) => (
                <div key={row.id} className={styles.bankCard}>
                  <div className={styles.bankCardTop}>
                    <img
                      className={styles.bankLogo}
                      src={gsbIcon}
                      alt="GSB"
                      loading="lazy"
                    />
                    <div className={styles.bankMeta}>
                      <span className={styles.bankName}>
                        ธนาคารออมสิน (GSB)
                      </span>
                      <span className={styles.bankNumber}>
                        {row.accountNumber}
                      </span>
                      <span className={styles.bankOwner}>
                        ชื่อบัญชี: {row.accountName}
                      </span>
                    </div>
                  </div>
                  <button
                    className={`${styles.copyBtn} ${copiedGsbId === row.id ? styles.copyBtnDone : ""}`}
                    onClick={() => {
                      navigator.clipboard.writeText(row.accountNumber);
                      setCopiedGsbId(row.id);
                      setTimeout(() => setCopiedGsbId(null), 2000);
                    }}
                  >
                    <Icon
                      icon={
                        copiedGsbId === row.id
                          ? "solar:check-circle-bold"
                          : "solar:copy-bold"
                      }
                      width={16}
                    />
                    {copiedGsbId === row.id ? "คัดลอกแล้ว" : "คัดลอกเลขบัญชี"}
                  </button>
                </div>
              ))}

              <div className={styles.instructionCard}>
                <div className={styles.instructionTitle}>📌 วิธีการฝากเงิน</div>
                <ul className={styles.instructionList}>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>1</span>
                    <span>
                      โอนเงินจากบัญชีที่ผูกไว้กับระบบ (ด้านล่าง) เข้าบัญชีออมสินข้างต้น
                    </span>
                  </li>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>2</span>
                    <span>
                      {gsbAccounts.some((row) => row.autoTopup)
                        ? "ระบบจะเติมเครดิตให้อัตโนมัติภายใน 1-5 นาที"
                        : "หลังโอนแล้ว กรุณาแจ้งเจ้าหน้าที่พร้อมสลิปเพื่อเติมเครดิต"}
                    </span>
                  </li>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>3</span>
                    <span>หากเครดิตไม่เข้า กรุณาติดต่อเจ้าหน้าที่</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

      {/* ── TrueMoney Wallet ── */}
      {selectedMethodData &&
        selectedMethodData.available &&
        method === "truemoney" && (
          <div className={styles.bankSection}>
            <div className={styles.bankSectionHeader}>
              <div className={styles.bankSectionIcon}>
                <Icon icon="solar:smartphone-2-bold" width={22} />
              </div>
              <div className={styles.bankSectionLabel}>
                <span className={styles.bankSectionTitle}>
                  {selectedMethodData.name}
                </span>
                <span className={styles.bankSectionHint}>
                  โอนเงินเข้า TrueMoney Wallet ด้านล่าง
                </span>
              </div>
            </div>
            <div className={styles.bankSectionBody}>
              {bankData
                .filter(
                  (data) =>
                    data.isMain === "MAINTMN" && data.status === "ACTIVE",
                )
                .map((row) => (
                  <div key={row.BanklistID} className={styles.bankCard}>
                    <div className={styles.bankCardTop}>
                      <img
                        className={styles.bankLogo}
                        src={truemoneyIcon}
                        alt="TrueMoney"
                        loading="lazy"
                      />
                      <div className={styles.bankMeta}>
                        <span className={styles.bankName}>
                          TrueMoney Wallet
                        </span>
                        <span className={styles.bankNumber}>
                          {row.banknumber}
                        </span>
                        <span className={styles.bankOwner}>
                          ชื่อเจ้าของ: {row.bankownername}
                        </span>
                      </div>
                    </div>
                    <button
                      className={`${styles.copyBtn} ${helper ? styles.copyBtnDone : ""}`}
                      onClick={() => {
                        navigator.clipboard.writeText(row.banknumber);
                        setHelper(true);
                        setTimeout(() => setHelper(false), 2000);
                      }}
                    >
                      <Icon
                        icon={
                          helper ? "solar:check-circle-bold" : "solar:copy-bold"
                        }
                        width={16}
                      />
                      {helper ? "คัดลอกแล้ว" : "คัดลอกเบอร์โทร"}
                    </button>
                  </div>
                ))}

              <div className={styles.instructionCard}>
                <div className={styles.instructionTitle}>📱 วิธีการฝากเงิน</div>
                <ul className={styles.instructionList}>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>1</span>
                    <span>โอนเงินเข้า TrueMoney Wallet ข้างต้น</span>
                  </li>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>2</span>
                    <span>
                      {gsbAccounts.some((row) => row.autoTopup)
                        ? "ระบบจะเติมเครดิตให้อัตโนมัติภายใน 1-5 นาที"
                        : "หลังโอนแล้ว กรุณาแจ้งเจ้าหน้าที่พร้อมสลิปเพื่อเติมเครดิต"}
                    </span>
                  </li>
                  <li className={styles.instructionItem}>
                    <span className={styles.stepNumber}>3</span>
                    <span>หากเครดิตไม่เข้า กรุณาติดต่อเจ้าหน้าที่</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

      {selectedMethodData &&
        selectedMethodData.available &&
        method === "slipupload" && (
          <SlipUploadPanel
            apiBaseUrl={API_BASE_URL}
            userId={storedId}
            styles={styles}
          />
        )}

      {/* ── QR Code Display ── */}
      {qrDataUrl && (
        <div className={styles.qrCard}>
          <div className={styles.qrSuccessBadge}>
            <Icon
              icon="mdi:check-circle"
              width={18}
              className={styles.qrSuccessIcon}
            />
            <span className={styles.qrSuccessText}>
              สแกน QR Code เพื่อทำธุรกรรม
            </span>
          </div>

          <div className={styles.qrImageWrap}>
            <img src={qrDataUrl} alt="QR Code" className={styles.qrImage} />
          </div>

          <div className={styles.qrAmountDisplay}>
            <span className={styles.qrAmountLabel}>จำนวนเงินที่ฝาก</span>
            <span className={styles.qrAmountValue}>
              ฿{Number(amount).toLocaleString()}
            </span>
          </div>

          {method === "bibpay" && bibpayData && (
            <div className={styles.bibpayDetails}>
              {bibpayData.data?.bank?.name && (
                <div className={styles.bibpayRow}>
                  <span className={styles.bibpayLabel}>ธนาคาร</span>
                  <span className={styles.bibpayValue}>
                    {bibpayData.data.bank.name}
                  </span>
                </div>
              )}
              {bibpayData.data?.bankNumber && (
                <div className={styles.bibpayRow}>
                  <span className={styles.bibpayLabel}>เลขบัญชี</span>
                  <span className={styles.bibpayValue}>
                    {bibpayData.data.bankNumber}
                  </span>
                </div>
              )}
              {bibpayData.data?.bankName && (
                <div className={styles.bibpayRow}>
                  <span className={styles.bibpayLabel}>ชื่อบัญชี</span>
                  <span className={styles.bibpayValue}>
                    {bibpayData.data.bankName}
                  </span>
                </div>
              )}
              {bibpayData.data?.depositAmount && (
                <div className={styles.bibpayRow}>
                  <span className={styles.bibpayLabel}>ยอดที่ต้องโอน</span>
                  <span className={styles.bibpayValue}>
                    {bibpayData.data.depositAmount} ฿
                  </span>
                </div>
              )}
              {bibpayData.data?.reference && (
                <div className={styles.bibpayRow}>
                  <span className={styles.bibpayLabel}>Ref</span>
                  <span className={styles.bibpayValue}>
                    {bibpayData.data.reference}
                  </span>
                </div>
              )}
            </div>
          )}

          <div
            className={`${styles.qrCountdown} ${
              countdown > 0
                ? styles.qrCountdownActive
                : styles.qrCountdownExpired
            }`}
          >
            <Icon
              icon={
                countdown > 0 ? "mdi:timer-outline" : "mdi:timer-off-outline"
              }
              width={18}
            />
            {countdown > 0
              ? `เวลาที่เหลือ ${formatTime(countdown)}`
              : "QR Code หมดอายุแล้ว"}
          </div>

          <div className={styles.qrActions}>
            <button className={styles.qrBtnSave} onClick={saveQr}>
              <Icon icon="mdi:download" width={16} />
              บันทึก QR
            </button>
            <button className={styles.qrBtnCancel} onClick={resetAll}>
              <Icon icon="mdi:close" width={16} />
              ยกเลิก
            </button>
          </div>
        </div>
      )}

      {/* ── User Bank Info ── */}
      {method !== "truemoney" && (
        <div className={styles.userBankSection}>
          <div className={styles.userBankHeader}>
            <div className={styles.userBankIcon}>
              <Icon icon="mdi:bank-outline" width={18} />
            </div>
            <span className={styles.userBankTitle}>
              ข้อมูลธนาคารของท่าน — โปรดใช้บัญชีนี้ในการโอน
            </span>
          </div>
          <div className={styles.userBankBody}>
            {account?.book_number ? (
              <div className={styles.userBankCard}>
                <img
                  className={styles.userBankLogo}
                  src={getBankLogo(account?.bank_name)}
                  alt={getBankName(account?.bank_name)}
                  loading="lazy"
                />
                <div className={styles.userBankMeta}>
                  <span className={styles.userBankName}>
                    {getBankName(account?.bank_name)}
                  </span>
                  <span className={styles.userBankNumber}>
                    {account?.book_number}
                  </span>
                  <span className={styles.userBankOwner}>
                    ชื่อบัญชี: {account?.book_name}
                  </span>
                </div>
              </div>
            ) : (
              <div className={styles.emptyBank}>
                <span className={styles.emptyBankEmoji}>🏦</span>
                <span className={styles.emptyBankTitle}>
                  ยังไม่มีบัญชีธนาคาร
                </span>
                <span className={styles.emptyBankDesc}>
                  กรุณาเพิ่มข้อมูลบัญชีธนาคารเพื่อทำธุรกรรม
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Warning ── */}
      <div className={styles.warningBox}>
        <span className={styles.warningEmoji}>⚠️</span>
        <span className={styles.warningText}>
          โปรดยืนยัน ชื่อ-สกุลผู้โอน ยอดที่โอน ให้ตรงกับระบบก่อนทำการโอนทุกครั้ง
          หากข้อมูลไม่ตรงกับระบบท่านจะไม่ได้รับเครดิต
          และระบบจะคืนเงินให้ท่านภายใน 3 วันทำการ
          หากมีข้อสงสัยกรุณาติดต่อเจ้าหน้าที่
        </span>
      </div>
    </div>
  );
}
